export default "__VITE_PUBLIC_ASSET__35529548__"